import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

function AnimalBoar() {
  return (
    <ItemPresenter imagePath={"/images/animals/boar.png"} bottomLabel={"Javali"}
      customImageWidth={" "}
      />
  );
}

export default AnimalBoar;